/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmConversationsDeleteItems } from "../../funcs/llmConversationsDeleteItems.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ConversationsItemsDeleteManyRequest$inboundSchema,
};

export const tool$llmConversationsDeleteItems: ToolDefinition<typeof args> = {
  name: "llm-conversations-delete-items",
  description: `Delete multiple conversation items

Delete multiple items from a conversation with the given ID.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmConversationsDeleteItems(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
